import { validateProducts, validateFilters, validateSearchMeta, validateSortOptions } from '../utils/validation';
export function mapProducts(products) {
    const mappedProducts = products.map((product) => {
        var _a, _b, _c, _d, _e;
        const priceMin = product.price_min;
        const compareAtPriceMin = (_a = product.compare_at_price_min) !== null && _a !== void 0 ? _a : 0;
        const data = {
            id: String(product.id),
            title: product.title,
            handle: product.handle,
            brand: product.vendor,
            color: '',
            size: [
                ''
            ],
            price: {
                regular: compareAtPriceMin > priceMin ? compareAtPriceMin : priceMin,
                sale: compareAtPriceMin > priceMin ? priceMin : undefined,
                special: undefined
            },
            image: {
                url: optimizeShopifyImage(product.images_info && ((_b = product.images_info[0]) === null || _b === void 0 ? void 0 : _b.src) || '', 1000),
                alt: product.images_info && ((_c = product.images_info[0]) === null || _c === void 0 ? void 0 : _c.alt) || `${product.title}-image`,
            },
            availability: product.available ? 'in_stock' : 'out_of_stock',
            metafields: (_d = product.metafields) === null || _d === void 0 ? void 0 : _d.map(mf => ({
                namespace: mf.namespace,
                key: mf.key,
                value: mf.value,
                type: mf.type
            })),
            variants: (_e = product.variants) === null || _e === void 0 ? void 0 : _e.map(variant => {
                return {
                    id: String(variant.id),
                    title: variant.title,
                    sku: variant.sku,
                    price: {
                        regular: parseFloat(variant.price),
                        sale: variant.compare_at_price ? parseFloat(variant.compare_at_price) : undefined
                    },
                    available: variant.available,
                    inventoryQuantity: variant.inventory_quantity,
                    merged_options: variant.merged_options,
                    image: variant.image || undefined
                };
            })
        };
        return data;
    });
    return validateProducts(mappedProducts, 'Boost');
}
export function mapFilters(filter, currentFilters) {
    const filters = [];
    if (!filter || !filter.options) {
        console.warn('[Boost Mapper] No filter or filter.options provided');
        return filters;
    }
    filter.options.map(option => {
        // Detect filter type based on filterOptionId
        let filterType = 'select';
        if (option.filterOptionId === 'color' ||
            option.filterOptionId.includes('color') ||
            option.filterOptionId.includes('colour')) {
            filterType = 'color';
        }
        const filter = {
            id: option.filterOptionId,
            label: option.label,
            type: filterType,
            options: []
        };
        if (option.displayType === 'list' && Array.isArray(option.values)) {
            filter.options = option.values.map((value) => {
                var _a;
                const key = String(value.key);
                const label = option.prefix && key.startsWith(option.prefix) ? key.slice(option.prefix.length) : key;
                return {
                    id: key,
                    label,
                    count: Number(value.doc_count),
                    selected: ((_a = currentFilters === null || currentFilters === void 0 ? void 0 : currentFilters[option.filterOptionId]) === null || _a === void 0 ? void 0 : _a.includes(key)) || false,
                    value: key
                };
            });
        }
        if (option.displayType === 'range') {
            filter.type = 'range';
            const rangeValues = option.values;
            if (option.filterType === 'price' && (currentFilters === null || currentFilters === void 0 ? void 0 : currentFilters.pf_p_price)) {
                filter.currentMin = Number(currentFilters.pf_p_price[0].split(":")[0]);
                filter.currentMax = Number(currentFilters.pf_p_price[0].split(":")[1]);
            }
            else {
                filter.currentMin = rangeValues === null || rangeValues === void 0 ? void 0 : rangeValues.min;
                filter.currentMax = rangeValues === null || rangeValues === void 0 ? void 0 : rangeValues.max;
            }
            filter.min = rangeValues === null || rangeValues === void 0 ? void 0 : rangeValues.min;
            filter.max = rangeValues === null || rangeValues === void 0 ? void 0 : rangeValues.max;
        }
        filters.push(filter);
    });
    return validateFilters(filters, 'Boost');
}
export function mapMeta(data, page, pageSize) {
    return validateSearchMeta({
        totalResults: data.total_product,
        totalPages: Math.ceil(data.total_product / pageSize),
        currentPage: page,
        pageSize
    }, 'Boost');
}
export function mapSorts() {
    return validateSortOptions([
        { id: 'manual', label: 'Default' },
        { id: 'relevance', label: 'Relevance' },
        { id: 'price_asc', label: 'Price Low to High' },
        { id: 'price_desc', label: 'Price High to Low' },
        { id: 'title_asc', label: 'Name A to Z' },
        { id: 'title_desc', label: 'Name Z to A' },
    ], 'Boost');
}
function optimizeShopifyImage(url, width) {
    if (!url || !url.includes('cdn.shopify.com'))
        return url;
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}width=${width}`;
}
